import { Controller } from "stimulus";
import Quill from "quill";
import SanitizingClipboard from "../../classes/sanitizingClipboard";

Quill.register("modules/clipboard", SanitizingClipboard, true);

export default class extends Controller {
  static get targets() {
    return ["hiddenField", "display"];
  }

  connect() {
    this.load();
  }

  load() {
    this.editor = new Quill("#" + this.displayTarget.id, this.options);
    this.editor.on("editor-change", this.updateHiddenField.bind(this));

    if (this.hiddenFieldTarget.value) {
      this.editor.setContents(this.editor.clipboard.convert(this.hiddenFieldTarget.value));
    }
  }

  // Read from the editor, as parsing its markup would report each style attribute to the policy.
  updateHiddenField() {
    const html = this.editor.root.innerHTML;
    this.hiddenFieldTarget.value = this.editor.root.textContent ? html : "";
  }

  handleHitEnter(event) {
    const enterKeyCode = 13;

    if (event.keyCode === enterKeyCode) {
      event.stopPropagation();
    }
  }

  get options() {
    return {
      placeholder: this.displayTarget.dataset.placeholder,
      modules: {
        toolbar: this.displayTarget.dataset.tools.split(" ")
      },
      theme: this.displayTarget.dataset.theme
    };
  }
}
